export default "__VITE_ASSET__0cb692d4__"